import { render, staticRenderFns } from "./RmaProductDetail.vue?vue&type=template&id=51d719e8&"
import script from "./RmaProductDetail.vue?vue&type=script&lang=js&"
export * from "./RmaProductDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports